import { render, staticRenderFns } from "./ReadingsBoard.vue?vue&type=template&id=125a1214&scoped=true&"
import script from "./ReadingsBoard.vue?vue&type=script&lang=ts&"
export * from "./ReadingsBoard.vue?vue&type=script&lang=ts&"
import style0 from "./ReadingsBoard.vue?vue&type=style&index=0&id=125a1214&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a1214",
  null
  
)

export default component.exports